module.exports = __webpack_public_path__ + "c229cf582334eca4e9d322f9ab1f5a9e.png";